// extracted by mini-css-extract-plugin
export default {"info":"Home_info__mYoib","products":"Home_products__uXl4T","text_center":"Home_text_center__KGMHT"};